<template>
  <div class="productcenterhtml">
    <div class="productcenterhead">
      <div class="productcenterheadtext">
        <p
          style="
            float: left;
            font-size: 18px;
            color: #275479;
            font-weight: bold;
            line-height: 30px;
            margin-left: 3px;
          "
        >
          价格研究
        </p>
      </div>
    </div>
    <div class="productcenterbody">
      <div class="productcenterbodytag">
        <ul style="padding-top: 70px">
            <li class="pli" v-for="(item,index) in leftnav" :key="index">
                <div v-bind:class="[item.active ? class4 : class3]"></div>
                <div v-bind:class="[item.active ? class1 : class5]" @click="show(index)">
                    <div style="width: 45px; height: 40px; float: left"></div>
                    <div class="tagmid">{{item.text}}</div>
                    <div style="width: 30px; height: 40px; float: left"></div>
                </div>
                <div style="width: 9px; height: 7px; float: left;position:absolute;right:1px;bottom:-7px">
                    <img
                        src="../../assets/images/lan-jia.png"
                        style="display: block"
                        v-if="item.active"
                    />
                </div>
            </li>
        </ul>
      </div>
      <div style="height: 18px"></div>
      <div class="productcenterbodytext" ref="box">
        <div
          style="
            width: 780px;

            border-radius: 2%;
            position: relative;
          "
        >
          <div class="midtext">
            <div v-if="leftnav.filter((el)=>{return el.id=='kzfx'})[0].active">
              <h4 class="head4" id="productcentertwo"></h4>
              <p class="pproduct">
                回归分析：根据K线图数据精确计算合约的相关性和线性关系，并提供散点图、回归方程、Beta、Alpha、R^2等专业统计指标，以进行价格预测、套利可行性检验等分析；
              </p>
              <p class="pproduct">
                波动率分析：基于历史数据统计短期和长期波动率指标，假设未来是历史的延伸，利用历史估计未来价格波动率，判断交易机会；
              </p>
              <p class="pproduct">
                季节性分析：按月记录合约价格趋势和涨幅并逐年横向对比，研究商品的周期性，掌握合约价格波动周期，提前部署交易计划；
              </p>
              <p class="pproduct">
                期货横截面：由不同交割月份合约的价格按照到期时间先后串联组成远期价格曲线，反应合约远期价格趋势。
              </p>
              <p class="pproduct">
                期现链：提供现货历史价格走势和距离交割日不同周期的价格点位标记，直观分析何时入场持有到期更加合理。
              </p>
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='gljy'})[0].active">
              <h4 class="head4" id="productcentertwo"></h4>
              <p class="pproduct">
               原创的期权/期货折算价算法，深度挖掘期货和期权价格的内在联系，用期权风险指标计算期货理论价格，用期货的涨跌计算期权理论价格，打通价格桥梁，提供价格研究新视角。
              </p>
              <p class="pproduct">
                例如，可以在期货走势图上看期权折算估值，辅助日内短线交易。当期货价格小于期权折算估值时，日内短线的交易策略是做多。
              </p>
              <BaseBigimg :src="require('@/../public/proimg/GLJY-1.jpg')"></BaseBigimg>
              <p class="pproduct">
                调用方法：自设页面，插入关联报价窗口；或者 系统k线图，右键菜单->关联报价。
              </p>
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='xhsj'})[0].active">
              <h4 class="head4" id="productcenterthree">
                
              </h4>
              <p class="pproduct">
                软件提供现货市场价格、库存、品种供需数据、进出口等丰富的产业数据。
              </p>
              <p class="pproduct">
                例如：期现比数据，反映市场未来的预期，期现比大于1，期货价格大于现货价格，预期价格会上涨；反之，期现比小于1，期货价格小于现货价格，预期价格下跌。
              </p>
              <p class="pproduct">
                当期现比出现异常时，结合分析基本面的变化，可以识别行情的趋势反转，如下图。
              </p>
              <BaseBigimg :src="require('@/../public/proimg/djxhsj.jpg')"></BaseBigimg>
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='gzx'})[0].active">
              <h4 class="head4" id="productcentersix"></h4>
              <p class="pproduct">
                传统的技术分析方法给出的信号，都是右侧信号，有明显的滞后性。
              </p>
              <p class="pproduct">
                估值线是一个左侧的价格研究方法！原创的估值算法，基于产业大数据，以及宏观基本面、进出口、汇率、市场情绪等数据，计算商品期货的估值，深挖引起商品价格变动的根本驱动，并在K线图上绘制估值线，为投资者提供寻找左侧买卖点的研究工具，根据价格与估值线的位置关系，分析当前价格的低估/高估情况，研判后期走势。
              </p>
              <BaseBigimg :src="require('@/../public/proimg/gz.jpg')"></BaseBigimg>
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='xwyb'})[0].active">
              <h4 class="head4" id="productcentersix"></h4>
              <p class="pproduct">
                小文研报采用大模型技术，依托文华财经30年积累的大型语料库，7*24小时、随时提供专业的商品研究报告。
              </p>
              <p class="pproduct">
                以文华自研商品研究框架为核心，对全球局势、宏观经济、产业链数据、政策动态等多维度信息进行深度解读和分析。从需求端、供给端、库存、现货市场、期货价格以及小文估值等多个维度，给出系统性、客观性的研判。为投资者把握商品趋势提供有据可依的重要参考。
              </p>
              <BaseBigimg :src="require('@/../public/proimg/xwyb.jpg')"></BaseBigimg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      leftnav:[
      {active:true,text:'小文研报',id:'xwyb'},
      {active:true,text:'小文估值',id:'gzx'},
      {active:false,text:'期现比',id:'xhsj'},
      {active:false,text:'期货/期权折算估值 ',id:'gljy'},
      {active:false,text:'扩展分析',id:'kzfx'},
      // {active:false,text:'产业数据',id:'cysj'},
      ],
      class1: "onclick",
      class2: "noclick",
      class3: "touming",
      class4: "yellow",
      class5: "noclickone",
      class6: "noclickele",
    };
  },
  methods: {
    show(index){
        console.log()
        this.leftnav.forEach((el,idx)=>{
            el.active=false
        })
        this.leftnav[index].active=true
    },
custormAnchor(anchorName) {
      // 找到锚点
      let anchorElement = document.getElementById(anchorName);
      console.log(anchorElement.scrollTop)
      // 如果对应id的锚点存在，就跳转到锚点
      if (anchorElement) {
        anchorElement.scrollIntoView();
      }
    },
   
  },
  mounted(){
    this.leftnav.forEach((el,idx)=>{
            el.active=false
    })
    this.leftnav.filter((el)=>{
      return el.id==this.$route.params.id
    })[0].active=true
    this.$nextTick(()=>{

      this.custormAnchor(this.$route.hash.split('#')[1]);
    })
  }

};
</script>

<style scoped>
.eeee {
  color: blue;
}
.eeee :visited {
  color: blue;
}
.productcenterhtml {
  background: url("../../assets/images/ts-bg_02.jpg") no-repeat top, #eef0ff;
  /* background-size: 100% 100%; */
  min-width: 1400px;
  width: 100%;
}
.productcenterhead {
  position: relative;
  height: 140px;
  width: 1000px;
  margin: 0 auto;
}
.productcenterheadtext {
  position: absolute;
  top: 105px;
  left: 3px;
}
.productcenterbody {
  width: 1000px;
  margin: 0 auto;
  position: relative;
}
.productcenterbodytag {
  width: 570px;
  height: 476px;
  border-radius: 2%;
  background: url("../../assets/images/ts-1_01.png") no-repeat center;
  /* background-size: 100% 100%; */
  position: absolute;
}
.productcenterbodytext {
  margin-left: 220px;
  width: 780px;
  border-top-left-radius: 1em;
  background: url("../../assets/images/ts-1_02.jpg") no-repeat top, #f7f7f7;
  background-size: 100%;
  overflow-x: hidden;
  filter: drop-shadow(1px 1px 2px #c2c5d4);
  min-height: 680px;
  z-index: 999;
}
.noclick {
  height: 41px;
  line-height: 41px;

  width: 220px;
  border-top: 1px solid #2f5476;
  letter-spacing: 1px;
  color: white;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.onclick {
  height: 42px;
  line-height: 42px;
  background: #fdfdfd;

  width: 220px;

  color: #395774;
  text-align: left;
  letter-spacing: 1px;

  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.touming {
  width: 5px;
  height: 42px;
  float: left;
}
.yellow {
  width: 5px;
  height: 42px;
  background: #e3a200;
  float: left;
  border-top-left-radius: 0.1em;
  border-bottom-left-radius: 0.1em;
}
.head4 {
  color: #245376;
  font-size: 16px;
  padding-top: 20px;
  padding-bottom: 10px;
  font-weight: bold;
  letter-spacing: 1px;
}
.midtext {
  width: 680px;
  margin: 0 auto;
  padding-bottom: 30px;
}
.pproduct {
  font-size: 15px;
  padding-top: 3px;
  padding-bottom: 3px;
  text-indent: 2em;
  color: #727983;
  line-height: 25px;
  /* width: 640px; */
  text-align: justify;
  letter-spacing: 1px;
}
.pimg {
  padding-top: 10px;
  padding-bottom: 10px;
  min-height: 50px;
  width: 100%;
  text-align: center;
}
.noclick:hover {
  color: #e3a200;
}
.pli {
  width: 235px;
  height: 42px;
  margin-left: -5px;
  position: relative;
  z-index: 88;
}
.noclickone {
  height: 41px;
  line-height: 41px;

  letter-spacing: 1px;
  width: 220px;

  border-top: 1px solid #2f5476;
  color: white;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.pli:last-child .noclickone{
  border-bottom: 1px solid #2f5476;
}
.noclickele {
  height: 40px;
  line-height: 40px;

  letter-spacing: 1px;
  width: 220px;
  border-top: 1px solid #2f5476;
  border-bottom: 1px solid #2f5476;
  color: white;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.noclickone:hover {
  color: #f59726;
}
.noclickele:hover {
  color: #f59726;
}
.tagmid {
  width: 130px;
  height: 42px;
  float: left;
  font-weight: bold;
}
.head5 {
  color: #245376;
  font-size: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: bold;
  letter-spacing: 1px;
}
</style>